import { Component, OnInit } from '@angular/core';
import { InventarioService } from 'src/app/services/inventario.service';
import Swal from 'sweetalert2';
import { mensajeSesionExpiradaService } from 'src/app/services/mensajeSesionExpirada.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

declare var $: any;

@Component({
  selector: 'app-listadodeviaticos',
  templateUrl: './listadodeviaticos.component.html',
  styleUrls: ['./listadodeviaticos.component.css']
})
export class ListadodeviaticosComponent implements OnInit {

  archivo: File | null = null;
  xmllista: any = [];
  xmlPreview: any = {};   

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();

  constructor(
    private inventarioService: InventarioService,
    private msj: mensajeSesionExpiradaService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      order: [[0, 'asc']],
      language: { url: 'https://cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json' }
    };
    this.getXMLlista();
  }

  getXMLlista() {
  this.inventarioService.getXMLlista().subscribe(
    res => {
      if (res === "TOKEN-EXPIRADO") {
        this.msj.tokenExpiradoCerrarSesion();
        return;
      }

      this.xmllista = res;

      // Si ya existe DataTable, destrúyelo antes de reiniciar
      if ($.fn.dataTable.isDataTable('.tabla-asignaturas')) {
        $('.tabla-asignaturas').DataTable().clear().destroy();
      }

      this.dtTrigger.next();
    },
    err => console.error(err)
  );
}

  abrirAgregarXML() {
    $('#Agrexml').modal('show');
  }

  cerrarAgregarXML() {
    $('#Agrexml').modal('hide');
  }

  cerrarPreviewXML() {
    $('#previewXML').modal('hide');
  }

  onFileSelected(event: any) {
    this.archivo = event.target.files[0];
    if (!this.archivo) return;

    const reader = new FileReader();

    reader.onload = () => {
      const xmlText = reader.result as string;

      // Parsear y extraer datos
      this.parseXML(xmlText);

     
      $('#Agrexml').modal('hide');

      setTimeout(() => {
        $('#previewXML').modal('show');
      }, 200); 
    };

    reader.readAsText(this.archivo);
  }

  parseXML(xml: string) {
    this.xmlPreview = {
      folio: this.extract(xml, /Folio="([^"]+)"/),
      subtotal: this.extract(xml, /SubTotal="([^"]+)"/),
      total: this.extract(xml, /Total="([^"]+)"/),

      rfc_emisor: this.extract(xml, /<cfdi:Emisor[^>]*Rfc="([^"]+)"/),
      nombre_emisor: this.extract(xml, /<cfdi:Emisor[^>]*Nombre="([^"]+)"/),

      rfc_receptor: this.extract(xml, /<cfdi:Receptor[^>]*Rfc="([^"]+)"/),
      nombre_receptor: this.extract(xml, /<cfdi:Receptor[^>]*Nombre="([^"]+)"/),

      uuid: this.extract(xml, /UUID="([^"]+)"/),
      no_certificado_sat: this.extract(xml, /NoCertificadoSAT="([^"]+)"/),
    };
  }

  extract(xml: string, regex: RegExp) {
    const match = xml.match(regex);
    return match ? match[1] : '';
  }

  confirmarXML() {
  this.inventarioService.guardarXMLmanual(this.xmlPreview).subscribe({
    next: res => {
      Swal.fire('XML guardado correctamente', '', 'success');
      this.cerrarPreviewXML();

      setTimeout(() => {
        this.getXMLlista();
      }, 1500); 
    },
    error: err => {
      console.error(err);
      Swal.fire('Error al guardar el XML', '', 'error');
    }
  });
}

}
